var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 574,
    height: 459,
    viewBox: "0 0 574 459",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7392 155.571C207.021 54 354.349 58.9649 373.36 11.2439C446.999 -84.1983 592.178 76.3117 592.178 173.03C592.178 268.17 533.74 299.513 360.158 392.611L358.5 393.5C307.906 420.636 183.159 502.327 100.52 429C17.8815 355.673 -61.9914 254.495 70.7392 155.571Z",
    fill: "#FE9342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.4e26fc591adef68d8b6d577d508b8233.svg";
export { ForwardRef as ReactComponent };